export default __webpack_public_path__ + "static/media/gallery_05.8cc9d4c9.jpg";